// extracted by mini-css-extract-plugin
module.exports = {"container":"GridContainer_container__ZNo2o","header":"GridContainer_header__1fhry","pagination":"GridContainer_pagination__ADnGx"};